export enum StrongFoot {
  Left = 'Left',
  Right = 'Right',
  Both = 'Both',
}
